








import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import VditorPreview from 'vditor'

@Component
export default class MarkdownViewer extends Vue {

  @Prop({ default: '' })
  readonly value!: string

  mounted () {
    this.view()
  }

  @Watch('value')
  update (value: string | undefined) {
    this.view()
  }

  view () {
    VditorPreview.preview(this.$refs.vditor as HTMLDivElement, this.value, {
      mode: 'dark',
      lang: 'en_US',
      markdown: {
        linkBase: document.location.pathname
      },
      math: {
        engine: 'KaTeX',
        // engine: 'MathJax',
        // macros: { packages: {'[+]': ['mhchem']} }
      }
    })
  }

  click ($event: MouseEvent) {
    const target = $event.target as HTMLAnchorElement
    if (target && target.nodeName === 'A') {
      if (target.origin !== document.location.origin) {
        $event.stopPropagation()
        $event.preventDefault()
        var win = window.open(target.href, '_blank')
        win?.focus()
      }
    }
    // const target = $event.target as HTMLAnchorElement
    // if (target && target.nodeName === 'A') {
    //   // @ts-ignore
    //   const href = target.attributes?.href?.value
    //   if (href) {
    //     $event.stopPropagation()
    //     $event.preventDefault()
    //     if (href === target.hash) {
    //       const link = document.location.pathname + target.hash
    //       document.location.replace(link)
    //     } else {
    //       var win = window.open(target.href, '_blank')
    //       win?.focus()
    //     }
    //   }
    // }
  }
}
